import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";

const UserDetailsPage = () => {
  const { id, cid } = useParams();
  const [company, setCompany] = useState(null);
  const [history, setHistory] = useState([]);
  const [scanDetails, setScanDetails] = useState({});

  useEffect(() => {
    const token = localStorage.getItem("superAdminToken");

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/admin/details/${id}`, config)
      .then((res) => {
        const adminData = res.data.admin;
        setCompany(adminData);
        // setCompanyId(adminData.cid);

        // Now safely use the cid directly here
        axios
          .get(
            `${process.env.REACT_APP_BACKEND_URL}/api/form/getScanCount?companyId=${adminData.cid}`
          )
          .then((res) => {
            setScanDetails(res.data);
          })
          .catch((err) => console.error("Error loading scan count:", err));
      })
      .catch((err) => console.error("Error loading company:", err));

    axios
      .get(
        `${process.env.REACT_APP_BACKEND_URL}/api/plan/history/${cid}`,
        config
      )
      .then((res) => setHistory(res.data.history || []))
      .catch((err) => console.error("Error loading history:", err));
  }, [id, cid]);

  if (!company) return <div>Loading...</div>;

  return (
    <div className="container mt-24">
      <div className="card radius-16 p-24 mb-32">
        <h4 className="mb-16">Company Info</h4>
        <div className="row">
          <div className="col-md-6 mb-12">
            <strong>Company Name:</strong> {company.name}
          </div>
          <div className="col-md-6 mb-12">
            <strong>Company ID:</strong> {company.cid}
          </div>
          <div className="col-md-6 mb-12">
            <strong>Email:</strong> {company.email}
          </div>
          <div className="col-md-6 mb-12">
            <strong>Mobile:</strong> +91 {company.cmobile}
          </div>
          <div className="col-md-6 mb-12">
            <strong>Plan Type:</strong> {company.plan?.toUpperCase() || "N/A"}
          </div>
          <div className="col-md-6 mb-12">
            <strong>Subscription Type:</strong>{" "}
            {company.planCategory?.toUpperCase() || "N/A"}
          </div>
          {company.planCategory !== "pro" && (
            <div className="col-md-6 mb-12">
              <strong>Scans Left:</strong> {" "}
              {scanDetails.monthlyScanLimit - (scanDetails.count || 0)}/{scanDetails.monthlyScanLimit}
            </div>
          )}
          <div className="col-md-6 mb-12">
            <strong>GST Number:</strong> {company.gstn || "N/A"}
          </div>
          <div className="col-md-6 mb-12">
            <strong>Status:</strong>{" "}
            <span
              className={`${
                new Date(
                  company.plan === "trial"
                    ? company.trialEndDate || 0
                    : company.licenseExpiryDate || 0
                ).setHours(23, 59, 59, 999) >= new Date()
                  ? "bg-success-focus text-success-main"
                  : "bg-danger-focus text-danger-main"
              } px-24 py-4 rounded-pill fw-medium text-sm`}
            >
              {new Date(
                company.plan === "trial"
                  ? company.trialEndDate || 0
                  : company.licenseExpiryDate || 0
              ).setHours(23, 59, 59, 999) >= new Date()
                ? "Active"
                : "Expired"}
            </span>
          </div>
        </div>
      </div>

      <div className="card radius-16 p-24">
        <h4 className="mb-16">Subscription History</h4>
        {history.length === 0 ? (
          <div className="text-center py-24 text-muted">
            No subscription history available.
          </div>
        ) : (
          <div className="table-responsive">
            <table className="table bordered-table sm-table">
              <thead>
                <tr>
                  <th className="text-center">License Key</th>
                  <th className="text-center">Plan Type</th>
                  <th className="text-center">Subscription Type</th>
                  <th className="text-center">Start Date</th>
                  <th className="text-center">End Date</th>
                  <th className="text-center">Validity</th>
                  <th className="text-center">Reason</th>
                  <th className="text-center">Status</th>
                </tr>
              </thead>
              <tbody>
                {history.map((plan, idx) => {
                  const now = new Date();
                  const start = new Date(plan.startDate);
                  const end = new Date(plan.endDate.split("T")[0]);
                  end.setHours(23, 59, 59, 999); // Adjust here

                  let statusClass = "bg-danger-focus text-danger-main";
                  let status = "Expired";

                  if (start <= now && end >= now) {
                    status = "Active";
                    statusClass = "bg-success-focus text-success-main";
                  } else if (start > now) {
                    status = "Upcoming";
                    statusClass = "bg-warning-focus text-warning-main";
                  }

                  return (
                    <tr key={idx}>
                      <td className="text-center">{plan.licenseKey}</td>
                      <td className="text-center">
                        {plan.planType?.toUpperCase()}
                      </td>
                      <td className="text-center">
                        {plan.planCategory?.toUpperCase() || "N/A"}
                      </td>
                      <td className="text-center">
                        {!isNaN(start)
                          ? start.toLocaleDateString("en-IN")
                          : "-"}
                      </td>
                      <td className="text-center">
                        {!isNaN(end) ? end.toLocaleDateString("en-IN") : "-"}
                      </td>
                      <td className="text-center">{plan.validityDays} days</td>
                      <td className="text-center">{plan.reason || "-"}</td>
                      <td className="text-center">
                        <span
                          className={`badge px-16 py-4 rounded-pill fw-medium ${statusClass}`}
                        >
                          {status}
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserDetailsPage;
